import React, {useState} from 'react'
import AddButton from '../../../shared/actionButtons/AddButton'
import DeleteButton from '../../../shared/actionButtons/DeleteButton'
import EditButton from '../../../shared/actionButtons/EditButton'
import DeleteModals from './DeleteModals'
import ExperienceModal from './EditModals/ExperienceModal'

type Props = {}

function Experience({}: Props) {
  const [experienceModal, setexperienceModal] = useState(false)
  const [deleteModal, setdeleteModal] = useState(false)

  const [activeExperience, setactiveExperience] = useState<string>('')
  const handleExperienceModal = () => {
    setexperienceModal(!experienceModal)
  }
  const handleDeleteModal = () => {
    setdeleteModal(!deleteModal)
  }
  return (
    <div className='card-body pt-9 pb-0 '>
      <div className='d-flex'>
        <ExperienceModal editModal={experienceModal} handleEditModal={handleExperienceModal} />
        <DeleteModals
          handleDeleteModal={handleDeleteModal}
          title={activeExperience}
          deleteModal={deleteModal}
        />

        <div className='fs-3 fw-bold mb-9'> Experience</div>
        <div>
          <AddButton handleAddModal={handleExperienceModal} title={'Add '} />
        </div>
      </div>
      <div className='mb-9'>
        <div className='mb-8'>
          <div className='d-flex justify-content-between'>
            <div className='d-flex flex-column flex-wrap'>
              <div className=''>
                <div className='fs-3   mb-2 text-uppercase'> X-panol LLC</div>

                <span className='fs-sm '> January 2018 - September 2019</span>
              </div>
              <div className=''>
                <span className=' fs-5 '>
                  {' '}
                  Xpanol is a virtual reality company that is working on providing virtual tourism
                </span>
              </div>
            </div>

            <div className=' d-flex justify-content-start align-items-center   '>
              <EditButton handleEditModal={handleExperienceModal} />
              <DeleteButton
                handleDeleteModal={handleDeleteModal}
                setActive={setactiveExperience}
                activeItem={'xpanol from your experience list'}
                className='mx-2'
              />
            </div>
          </div>
        </div>
        <div className='mb-4'>
          <div className='d-flex justify-content-between'>
            <div className='d-flex flex-column flex-wrap'>
              <div className=''>
                <div className='fs-3   mb-2 text-uppercase'> X-panol LLC</div>

                <span className='fs-sm '> January 2018 - September 2019</span>
              </div>
              <div className=''>
                <span className=' fs-5 '>
                  {' '}
                  Xpanol is a virtual reality company that is working on providing virtual tourism
                </span>
              </div>
            </div>

            <div className=' d-flex justify-content-start align-items-center   '>
              <EditButton handleEditModal={handleExperienceModal} />
              <DeleteButton
                handleDeleteModal={handleDeleteModal}
                setActive={setactiveExperience}
                activeItem={'xpanol 2 from your experience list'}
                className='mx-2'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Experience
